import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  FileText,
} from 'lucide-react';
import AppShell from '../layouts/AppShell';
import UserProfileButton from '../components/UserProfileButton';
import EmptyState from '../components/EmptyState';
import SubmittedNoteCard from '../components/SubmittedNoteCard';
import { useSession } from '../contexts/SessionContext';
import { useLanguage } from '../contexts/LanguageContext';
import { getReportTypeLabel } from '../i18n/translations';
import { getPatientById, getPatientDisplayName } from '../constants/mockPatients';
import { reportPath } from '../constants/routes';

export default function ReportsListScreen() {
  const navigate = useNavigate();
  const { reports, admittedPatients } = useSession();
  const { t, language } = useLanguage();

  return (
    <AppShell>
      <header className="sticky top-0 z-30 border-b border-gray-200 bg-surface px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="text-primary"
              aria-label={t('back')}
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
            <div>
            <h1 className="text-page-title">{t('reports')}</h1>
            <p className="text-xs text-gray-500">{t('shiftReports')}</p>
            </div>
          </div>
          <UserProfileButton />
        </div>
      </header>

      <div className="space-y-3 px-4 py-4">
        {reports.length === 0 ? (
          <EmptyState icon={FileText} title={t('noReportsYet')} />
        ) : (
          reports.map((report) => {
            const patient = report.patientId ? getPatientById(report.patientId, admittedPatients) : null;
            const patientName = patient
              ? getPatientDisplayName(patient, language)
              : report.patientName;
            const noteType =
              report.type === 'shift_handover' ? 'shift_handover' : report.type;
            return (
              <SubmittedNoteCard
                key={report.id}
                patientName={patientName}
                noteType={noteType}
                noteTypeLabel={getReportTypeLabel(t, report.type)}
                note={report.note}
                onOpen={() => navigate(reportPath(report.id), { state: { report } })}
                viewLabel={t('view')}
              />
            );
          })
        )}
      </div>
    </AppShell>
  );
}
